// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2M08q","title":"InfoRow_title__NgR8-"};